<script setup>
import { ref } from "vue"
import { useRoute } from "vue-router"

import Layout from "@/layouts/main.vue"
import PageHeader from "@/components/page-header"

import store from "../../state/store"
import ServiceListItemTable from "./service-list-items-table.vue"
import ServiceListItemModal from "./service-list-item-modal.vue"
import ServiceListItemEditModal from "./service-list-item-edit-modal.vue"

const title = "Elemente der Serviceliste"
const pageTitle = "Armaturenbrett"

const route = useRoute()
const serviceId = route.params.serviceId

const DEFAULT_LIST_ITEM = {
  id: "",
  service_id: "",
  service_title_en: "",
  service_title_de: "",
  item_title_en: "",
  item_title_de: "",
  item_description_de: "",
  item_description_en: "",
}

const listItemModel = ref({ ...DEFAULT_LIST_ITEM })
const showListItemModal = ref(false)
const showListItemEditModal = ref(false)

const showAddNewModal = () => {
  showListItemModal.value = true
}

const showEditModal = () => {
  showListItemEditModal.value = true
}

function editListItem(listItem) {
  store.dispatch("getServiceListItem", listItem.id).then(({ data }) => {
    listItemModel.value = data.data

    console.log(listItemModel.value);
    showEditModal()
  })
}

const onModalClose = () => {
  listItemModel.value = { ...DEFAULT_LIST_ITEM }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :pageTitle="pageTitle" />

    <BRow>
      <BCol lg="12">
        <BCard no-body id="serviceListItems">
          <BCardHeader class="border-bottom-dashed">
            <BRow class="g-4 align-items-center">
              <BCol sm>
                <div>
                  <h5 class="card-title mb-0">
                    Liste der Servicelistenelemente
                  </h5>
                </div>
              </BCol>
              <BCol sm="auto">
                <div class="d-flex flex-wrap align-items-start gap-2">
                  <BButton
                    type="button"
                    variant="success"
                    class="add-btn me-1"
                    id="create-btn"
                    @click="showAddNewModal()"
                  >
                    <i class="ri-add-line align-bottom me-1"></i> Füge neuen
                    Gegenstand hinzu
                  </BButton>
                </div>
              </BCol>
            </BRow>
          </BCardHeader>

          <!-- service list items table  -->

          <ServiceListItemTable
            :serviceId="serviceId"
            @clickEdit="editListItem"
          />

          <!-- add and edit service list item modal  -->

          <ServiceListItemModal
            v-model="showListItemModal"
            :serviceId="serviceId"
            :listItem="listItemModel"
            @close="onModalClose"
          />

          <ServiceListItemEditModal
            v-model="showListItemEditModal"
            :listItem="listItemModel"
            @close="onModalClose"
          />
        </BCard>
      </BCol>
    </BRow>
  </Layout>
</template>
